<template>
  <v-container>
    <div class=" pb-3">
      <v-img src="@/assets/ImageINET-Marketplace/ICONShop/BannerCreateShop.png" class="rounded-xl"></v-img>
    </div>
    <v-card class="container">
      <v-row justify="center" dense no-gutters>
        <v-img src="@/assets/ImageINET-Marketplace/ICONShop/step1.png" contain max-height="108" max-width="576"
          class="mt-12 mb-10" v-if="stepper === 1"></v-img>
        <v-img src="@/assets/ImageINET-Marketplace/ICONShop/step2.png" contain max-height="108" max-width="576"
          class="mt-12 mb-10" v-else-if="stepper === 2"></v-img>
      </v-row>
      <v-card elevation="0" width="100%" height="100%"
        style="background: #FAFAFA; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15); border-radius: 8px;">
        <v-form ref="formRegis" :lazy-validation="lazy">
          <!-- stepper 1 -->
          <v-card-text v-if="stepper === 1">
            <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon>
            <span style="font-weight: 600; font-size: 16px; line-height: 24px; color: #333333;">ข้อมูลทั่วไป</span>
            <!-- รูปภาพ -->
            <v-col cols="12" md="12" class="mt-6 px-0">
              <v-card elevation="0" width="100%" height="100%" style="background: #FFFFFF; border-radius: 8px;">
                <v-card-text>
                  <v-card elevation="0" style="border: 2px dashed #27AB9C; box-sizing: border-box; border-radius: 8px;"
                    @click="onPickFile()">
                    <v-card-text>
                      <v-row no-gutters align="center" justify="center" style="cursor: pointer;">
                        <v-file-input v-model="DataImage" :items="DataImage" accept="image/jpeg, image/jpg, image/png" @click="event => event.target.value = null"
                          @change="UploadImage()" id="file_input" multiple :clearable="false" style="display:none">
                        </v-file-input>
                        <v-col cols="12" md="12" class="mb-6">
                          <v-row justify="center" class="pt-10">
                            <v-img src="@/assets/ImageINET-Marketplace/ICONShop/uploadImg.png" width="280.34"
                              height="154.87" contain></v-img>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-6">
                          <v-row justify="center" align="center">
                            <v-col cols="12" md="5" style="text-align: center;">
                              <span
                                style="font-size: 16px; line-height: 24px; font-weight: 400;">เพิ่มรูปภาพของคุณที่นี่</span><br />
                              <span
                                style="font-size: 16px; line-height: 24px; font-weight: 400;">หรือเลือกรูปภาพจากคอมพิวเตอร์ของคุณ</span><br />
                              <span style="font-size: 12px; line-height: 16px; font-weight: 400;">(ไฟล์นามสกุล .JPEG,
                                .PNG
                                เพิ่มได้สูงสุด 6 รูปภาพ)</span><br />
                              <span style="font-size: 12px; line-height: 16px; font-weight: 400;"><span
                                  style="color: red;">***</span> หมายเหตุ
                                ไฟล์รูปควรมีขนาดไม่เกิน 2 MB</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <span style="font-size: 12px; line-height: 16px; font-weight: 400;">
                    <span style="color: red;">***</span> หมายเหตุ รูปแรกจะเป็นรูปโปรไฟล์(Profile)
                  </span>
                  <div v-if="Detail.product_image.length !== 0" class="mt-4">
                    <draggable v-model="Detail.product_image" :move="onMove" @start="drag=true" @end="drag=false"
                    class="pl-5 pr-5 row  fill-height align-center sortable-list">
                      <v-col v-for="(item, index) in Detail.product_image" :key="index" cols="12" sm="6" md="2">
                        <v-card v-if="item.type === 'image'" outlined class="pa-1" width="146" height="146">
                          <v-img :src="item.path" :lazy-src="item.url" width="136" height="136" contain>
                            <v-btn icon x-small style="float: right; background-color: #ff5252;">
                              <v-icon x-small color="white" dark @click="RemoveImage(index, item)">mdi-close</v-icon>
                            </v-btn>
                          </v-img>
                        </v-card>
                      </v-col>
                    </draggable>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- ประเภทธุรกิจ ชื่อร้านค้า เลขประจำตัว URL-->
            <v-row no-gutters>
              <!-- ประเภทธุรกิจ -->
              <v-col cols="12" md="12" class="">
                <v-col cols="12" md="12" class="pb-0">
                  <span class="f-left"
                    style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">ประเภทธุรกิจ</span>
                </v-col>
              </v-col>
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-radio-group v-model="bussinessType" mandatory row disabled>
                  <v-radio label="นิติบุคคลอื่นๆ" style="color: #333333;" value="citizen"></v-radio>
                  <v-radio label="นิติบุคคล" style="color: #333333;" value="business"></v-radio>
                </v-radio-group>
              </v-col>
              <!-- ชื่อร้านค้า เลขประจำตัว-->
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-row dense no-gutters>
                  <!-- ชื่อร้านค้า -->
                  <v-col cols="12" md="6">
                    <v-row dense>
                      <v-col cols="12">
                        <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">ชื่อร้านค้า
                          <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" class="pr-4">
                        <v-text-field
                        v-model="shopName"
                        outlined dense
                        :error="this.v && this.shopName === null ? true : false "
                        :maxLength="30"
                        background-color="#FFFFFF"
                        placeholder="ระบุชื่อร้านค้าไม่เกิน 30 ตัวอักษร"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- เลขประจำตัว -->
                  <v-col cols="12" md="6">
                    <v-row dense>
                      <v-col cols="12">
                        <span
                          style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">เลขประจำตัวผู้เสียภาษีอากร
                          <span style="color: red;">*</span></span>
                      </v-col>
                      <v-col cols="12" class="pr-4">
                        <v-text-field v-model="taxNumber" outlined dense :maxLength="13" :rules="Rules.Idcard"
                          :error="this.v && this.taxNumber === null ? true : false "
                          placeholder="ระบุเลขประจำตัวผู้เสียภาษี 13 หลัก" disabled></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <!-- URL เบอร์โทรศัพท์ Facebook Line-->
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-row dense no-gutters>
                  <!-- URL ร้านค้า -->
                  <v-col cols="12" md="6">
                    <v-row dense>
                      <v-col cols="12">
                        <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">URL ร้านค้า</span>
                      </v-col>
                      <v-col cols="12" class="pr-4">
                        <v-text-field v-model="urlname" background-color="#FFFFFF" outlined dense placeholder="ระบุ url ร้านค้า"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- เบอร์โทรศัพท์ -->
                  <v-col cols="12" md="6">
                    <v-row dense>
                      <v-col cols="12">
                        <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">เบอร์โทรศัพท์ </span>
                        <span style="color: red;">*</span>
                      </v-col>
                      <v-col cols="12" class="pr-4">
                        <v-text-field v-model="mobile" outlined dense :maxLength="20" :rules="Rules.tel" background-color="#FFFFFF"
                          placeholder="ระบุเบอร์โทรศัพท์"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- Facebook  -->
                  <!-- <v-col cols="12" md="4">
                    <v-row dense>
                      <v-col cols="12">
                        <span
                          style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">Facebook</span>
                      </v-col>
                      <v-col cols="12" class="pr-4">
                        <v-text-field v-model="facebook" background-color="#FFFFFF" outlined dense placeholder="ระบุ Facebook"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col> -->
                  <!-- Line -->
                  <!-- <v-col cols="12" md="4">
                    <v-row dense>
                      <v-col cols="12">
                        <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">Line</span>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="line" outlined dense placeholder="ระบุ ID LINE" background-color="#FFFFFF"
                          oninput="this.value = this.value.replace(/[^a-z0-9_.-\s]/g, '')"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col> -->
                  <!-- openshop partner merchant_key -->
                  <!-- <v-row dense no-gutters>
                    <v-col cols="12" md="7" style="margin-left: -5px">
                      <v-col cols="12" md="12">
                        <v-row dense no-gutters>
                          <v-col cols="12" md="5" class="mb-4">
                            <span style="font-weight: 600; font-size: 14px; line-height: 22px; color: #333333;">ข้อมูลการเปิด - ปิด ร้านค้า</span>
                            <v-switch v-model="openshop" label="เปิด-ปิดร้านค้า" color="#27AB9C" style="font-size: 14px !important;" inset hide-details></v-switch>
                          </v-col>
                          <v-col cols="12" md="12">
                            <span class="f-left"
                              style="font-weight: 600; font-size: 14px; line-height: 22px; color: #333333;">ข้อมูลการขอเป็นคู่ค้า
                            </span>
                            <v-switch v-model="partner" label="เปิด-ปิดการขอเป็นคู่ค้า" inset
                              style="font-size: 14px !important;" color="#27AB9C" hide-details></v-switch>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <span
                          style="font-weight: 600; font-size: 14px; line-height: 22px; color: #333333;">ข้อมูลการเงิน
                        </span>
                        <v-row>
                          <v-col cols="12" md="6" class="mt-3">
                            <h4>รหัสการจ่ายเงิน</h4>
                            <v-text-field outlined dense width="100" v-model="merchant_key"
                              placeholder="ระบุรหัสการจ่ายเงิน ( Merchant Key)">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row> -->
                </v-row>
              </v-col>
              <!-- เกี่ยวกับร้านค้า -->
              <v-col cols="12" md="12" class="px-2 py-0">
                <v-col cols="12" md="12" class="pb-0">
                  <span class="f-left"
                    style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">เกี่ยวกับร้านค้า</span>
                </v-col>
              </v-col>
              <v-col cols="12" md="12" class="px-2 pt-2">
                <v-textarea v-model="descriptionShop" placeholder="อธิบายเกี่ยวกับร้านค้าของคุณ"
                  background-color="#FFFFFF" outlined height="123"></v-textarea>
              </v-col>
            </v-row>
            <!-- nextStep -->
            <v-row dense justify="end">
              <v-btn color="#27AB9C" class="px-8 mr-2" outlined dark @click="backtoMenu()">ยกเลิก</v-btn>
              <v-btn color="#27AB9C" class="px-8" dark @click="nextStep(2)">ถัดไป</v-btn>
            </v-row>
          </v-card-text>

           <!-- stepper 2 -->
          <v-card-text v-else-if="stepper === 2">
            <v-row dense no-gutters class="mt-0">
              <v-col cols="12" md="12" class="mb-5">
                <span class="f-left"
                  style="font-weight: 400; font-size: 18px; line-height: 22px; color: #333333;">แก้ไขที่อยู่</span>
              </v-col>
              <v-col cols="12" md="6">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">ชื่อ <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field v-model="name_profile" background-color="#FFFFFF" outlined dense placeholder="ระบุชื่อ"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">นามสกุล <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field v-model="last_name" background-color="#FFFFFF" outlined dense placeholder="ระบุนามสกุล"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">อีเมล </span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field :rules="Rules.email" v-model="email_profile" background-color="#FFFFFF" outlined dense placeholder="ระบุอีเมล"
                      required></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span
                      style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">หมายเลขโทรศัพท์ <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field v-model="phone_profile" background-color="#FFFFFF" outlined dense :maxLength="10" :rules="Rules.tel" maxlen="10"
                      placeholder="ระบุหมายเลขโทรศัพท์ 10 หลัก"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span
                      style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">รายละเอียดที่อยู่
                    </span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field v-model="details_profile" background-color="#FFFFFF" outlined dense placeholder="ระบุรายละเอียดที่อยู่">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">เลขที่ <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <v-text-field v-model="house_no" outlined dense background-color="#FFFFFF"
                      oninput="this.value = this.value.replace(/[^0-9\s\/]/g, '').replace(/(\..*)\./g, '$1')"
                      placeholder="ระบุบ้านเลขที่" :rules="Rules.house_Num"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">แขวง/ตำบล <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <addressinput-subdistrict :rules="Rules.empty" label=""
                      :class="checkSubDistrictError ? 'input_text-thai-address-error' : 'input_text-thai-address'"
                      v-model="subdistrict" placeholder="ระบุแขวง/ตำบล" />
                    <div v-if="checkSubDistrictError" class="text-error">ข้อมูลไม่ถูกต้อง</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">เขต/อำเภอ <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <addressinput-district label="" v-model="district"
                      :class="checkDistrictError ? 'input_text-thai-address-error' : 'input_text-thai-address'"
                      placeholder="ระบุเขต/อำเภอ" />
                    <div v-if="checkDistrictError" class="text-error">ข้อมูลไม่ถูกต้อง</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">จังหวัด <span
                        style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <addressinput-province label=""
                      :class="checkProvinceError ? 'input_text-thai-address-error' : 'input_text-thai-address'"
                      v-model="province" placeholder="ระบุจังหวัด" />
                    <div v-if="checkProvinceError" class="text-error">ข้อมูลไม่ถูกต้อง</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="mb-2">
                <v-row dense>
                  <v-col cols="12">
                    <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">รหัสไปรษณีย์
                      <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="12" class="pr-4">
                    <addressinput-zipcode numbered label=""
                      :class="checkZipcodeError ? 'input_text-thai-address-error' : 'input_text-thai-address'"
                      v-model="zipcode" placeholder="ระบุรหัสไปรษณีย์" />
                    <div v-if="checkZipcodeError" class="text-error">ข้อมูลไม่ถูกต้อง</div>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col cols="12" md="12" class="mt-5">
                <v-row dense>
                  <v-col cols="12" class="pr-4 ml-3">
                    <v-row>
                      <v-checkbox v-model="default_address" color="#27AB9C" value="main" :success="true"></v-checkbox>
                      <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;"
                        class="pt-5">ตั้งค่าเป็นที่อยู่เริ่มต้น</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col> -->
            </v-row>
            <v-row dense justify="end">
              <v-btn color="#27AB9C" class="px-4 mr-2" outlined dark @click="nextStep(1)">ย้อนกลับ</v-btn>
              <v-btn color="#27AB9C" class="px-8" dark @click="openModal()">ถัดไป</v-btn>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-card>

    <!-- dialog -->
    <v-dialog v-model="dialog" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px">
            <font color="#27AB9C">แก้ไขข้อมูลร้านค้า</font>
          </span>
          <v-btn icon dark @click="dialog = false">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br /><br />
        <v-card-text>
          <span>
            คุณได้ทำการแก้ไขข้อมูลร้านค้า<br />
            คุณต้องการทำรายการนี้ ใช่ หรือไม่
          </span>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-btn dense dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeModal()">ยกเลิก</v-btn>
            <v-btn dense color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="seve_edit_shop()">ตกลง</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Decode, Encode } from '@/services'
export default {
  data () {
    return {
      seller_shop_id: '',
      // old data
      stepper: 1,

      // data detail
      shopEmail: [],
      shopPhone: [],
      // stepper1
      bussinessType: '',
      DataImage: [],
      Detail: {
        product_image: []
        // shop_name_th: '',
        // shop_name_en: '',
        // shop_description: '',
        // path_logo: ''
      },
      v: false,
      shopName: '',
      taxNumber: '',
      urlname: '',
      descriptionShop: '',
      mobile: '',
      facebook: '',
      line: '',
      openshop: false,
      publicshop: false,
      merchant_key: '',

      // stepper2
      name_profile: '',
      last_name: '',
      email_profile: '',
      email_id: '',
      phone_profile: '',
      shop_address: '',
      details_profile: '',
      house_no: '',
      subdistrict: '',
      district: '',
      province: '',
      zipcode: '',
      checkSubDistrictError: false,
      checkDistrictError: false,
      checkProvinceError: false,
      checkZipcodeError: false,
      default_address: '',

      // dialog
      dialog: false,

      // details: '',
      selects: '',
      category: '',
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      SCG: '',
      flash: '',
      shop_cost: false,

      // img: '',
      idTell: '',
      Rules: {
        // stepper1
        Idcard: [
          v => /^[0-9]+$/.test(v) || 'กรุณากรอกเฉพาะตัวเลข'
        ],
        tel: [
          v => !!v || 'กรุณากรอกเบอร์โทรศัพท์',
          v => (v.length >= 9 && v.length <= 20) || v === '' || 'กรุณากรอกเบอร์ติดต่ออย่างน้อย 9 และไม่เกิน 20 หลัก'
        ],
        // stepper2
        email: [
          v => !!v || 'กรุณาระบุอีเมล',
          v => /^[a-zA-Z0-9._-]+@[a-zA-Z]+([.]?[a-zA-Z])*(\.[a-zA-Z]{2,3})+$/.test(v) || v === '' || 'กรุณากรอกอีเมลให้ถูกต้อง'
        ],
        house_Num: [
          v => !!v || 'กรุณากรอกข้อมูล'
        ],
        empty: [v => !!v || 'กรุณาเลือกข้อมูล'],

        bussinessType: [
          v => !!v || 'กรุณาเลือกประเภทธุรกิจ'
        ],
        shop_name: [
          v => !!v || 'กรุณากรอกชื่อร้านค้า'
        ],
        tax_id: [
          v => !!v || 'กรุณากรอกเลขประจำตัวผู้เสียภาษี',
          v => v.length >= 13 || 'กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ครับ 13 ตัว'
        ],
        firstname: [
          v => !!v || 'กรุณากรอกชื่อ'
        ],
        lastname: [
          v => !!v || 'กรุณากรอกนามสกุล'
        ],
        address: [
          v => !!v || 'กรุณาระบุที่อยู่'
        ],
        Merchant: [
          v => !!v || 'กรุณาระบุรหัสการจ่ายเงิน'
        ]
      },

      // ไม้ใช้
      partner: false,
      graczData: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/EditSellerShopMobile').catch(() => {})
      } else {
        this.$router.push('/Order/EditSellerShop').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    }
  },
  created () {
    window.scrollTo(0, 0)
    // this.$EventBus.$emit('changeNav')
    var shop = JSON.parse(Decode.decode(localStorage.getItem('GraczShopData')))
    this.seller_shop_id = shop.seller_shop_id
    this.getDetailShop()
    // var dataDetail1 = JSON.parse(Decode.decode(localStorage.getItem('list_shop_detail')))
    // if (dataDetail !== null) {
    //   if (dataDetail.can_use_function_in_shop.manage_setting_shop === '1') {
    //     this.getDetailShop()
    //   } else {
    //     this.$router.push({ path: '/' })
    //   }
    // } else {
    //   this.$router.push({ path: '/' })
    // }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopDetailMobile/undefined-undefined' })
      } else {
        this.$router.push({ path: '/Order/SellerShopDetail/undefined-undefined' })
      }
    },
    async getDetailShop () {
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczSellerShopPage', data)
      var response = await this.$store.state.ModuleGraczShop.stateGraczSellerShopPage
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      var shopDetail = response.data[0]

      // stepper1
      var img = shopDetail.shop_image
      for (let i = 0; i < img.length; i++) {
        var sent = {
          path: img[i].media_path,
          name: 'default',
          type: 'image',
          id: img[i].id
        }
        this.Detail.product_image.push(sent)
      }
      // console.log('image pass')
      this.bussinessType = shopDetail.shop_type
      this.shopName = shopDetail.shop_name
      this.taxNumber = shopDetail.tax_id
      this.urlname = shopDetail.url_name
      this.descriptionShop = shopDetail.shop_description
      this.shopPhone = shopDetail.shop_phone
      if (this.shopPhone.length !== 0) {
        this.mobile = shopDetail.shop_phone[0].phone
        if (this.shopPhone.length > 1) {
          for (let i = 0; i < this.shopPhone.length; i++) {
            if (i > 0) {
              this.phone_profile = shopDetail.shop_phone[i].phone
            }
          }
        }
      } else {
        this.mobile = ''
        this.phone_profile = ''
      }
      // console.log('shopPhone pass')
      this.facebook = shopDetail.facebook_url
      this.line = shopDetail.line_id
      // console.log(shopDetail.shop_status)
      if (shopDetail.shop_status === 'active') {
        this.openshop = true
      } else {
        this.openshop = false
      }
      if (shopDetail.have_partner === 'yes') {
        this.publicshop = true
      } else {
        this.publicshop = false
      }
      this.merchant_key = shopDetail.merchant_key

      // stepper2
      this.name_profile = shopDetail.first_name
      this.last_name = shopDetail.last_name
      this.shopEmail = shopDetail.shop_email
      if (this.shopEmail.length !== 0) {
        this.email_profile = shopDetail.shop_email[0].seller_email
        this.email_id = shopDetail.shop_email[0].id
      } else {
        this.email_profile = ''
        this.email_id = -1
      }
      // address
      this.shop_address = shopDetail.address_detail
      this.details_profile = this.shop_address[0].detail
      this.house_no = this.shop_address[0].house_no
      this.subdistrict = this.shop_address[0].sub_district
      this.district = this.shop_address[0].district
      this.province = this.shop_address[0].province
      this.zipcode = this.shop_address[0].zipcode
      this.default_address = this.shop_address[0].default_address

      if (shopDetail.partner_show === 'yes') {
        this.partner = true
      } else {
        this.partner = false
      }
      // this.img = shopDetail.shop_image
      // var email = shopDetail.shop_email
      // this.details = this.shop_address[0].details
      // this.idTell = shopDetail.shop_phone[0].id
    },
    // stepper
    nextStep (val) {
      if (this.$refs.formRegis.validate(true)) {
        this.stepper = val
        window.scrollTo(0, 0)
      }
    },
    // stepper1
    // picture
    onPickFile () {
      document.getElementById('file_input').click()
    },
    UploadImage () {
      if (this.Detail.product_image.length < 6) {
        for (let i = 0; i < this.DataImage.length; i++) {
          const element = this.DataImage[i]
          const imageSize = element.size / 1024 / 1024
          if (imageSize < 2) {
            const reader = new FileReader()
            reader.readAsDataURL(element)
            reader.onload = () => {
              var resultReader = reader.result
              var url = URL.createObjectURL(element)
              if (this.Detail.product_image.length < 6) {
                this.Detail.product_image.push({
                  image_data: resultReader.split(',')[1],
                  path: url,
                  name: this.DataImage[i].name,
                  type: (this.DataImage[i].type.split('/', 1)).toString()
                })
              } else {
                this.$swal.fire({
                  icon: 'warning',
                  text: 'กรุณาเพิ่มรูปภาพไม่เกิน 6 รูป',
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          } else {
            this.$swal.fire({
              icon: 'warning',
              text: 'กรุณาใส่รูปที่มีขนาดน้อยกว่า 2 MB',
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'warning',
          text: 'กรุณาเพิ่มรูปภาพไม่เกิน 6 รูป',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext
      const draggedElement = draggedContext
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    RemoveImage (index, val) {
      if (this.$route.query.Status === 'Edit') {
        if (val.id !== undefined) {
          this.Detail.remove_img.push({
            id: val.id
          })
        }
        this.Detail.product_image.splice(index, 1)
      } else {
        this.Detail.product_image.splice(index, 1)
      }
    },

    // stepper2
    openModal () {
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
      window.scrollTo(0, 0)
    },
    async seve_edit_shop () {
      // this.dialog = false
      if (this.$refs.formRegis.validate(true)) {
        // console.log('check form validate')
        if (this.shopName === '' || this.shopName === null || this.mobile === '' || this.mobile === null || this.taxNumber === '' || this.taxNumber === null || this.name_profile === '' || this.name_profile === null || this.last_name === '' || this.last_name === null) {
          this.$swal.fire({ text: 'กรุณากรอกข้อมูลให้ครบ', icon: 'error', timer: 2500, showConfirmButton: false })
          this.v = true
        } else {
          // console.log('assign data for edit')
          var list = []
          for (let i = 0; i < this.Detail.product_image.length; i++) {
            if (this.Detail.product_image[i].name === 'default') {
              list.push({
                id: this.Detail.product_image[i].id
              })
            } else {
              list.push({
                id: '-1',
                image_data: this.Detail.product_image[i].image_data
              })
            }
          }
          // console.log('picture list', list)
          var dataEdit = {
            seller_shop_id: this.seller_shop_id,
            // stepper1
            shop_type: this.bussinessType,
            shop_image: list,
            shop_name: this.shopName,
            tax_id: this.taxNumber,
            shop_url: this.urlname,
            shop_description: this.descriptionShop,
            shop_phone: [
              {
                id: -1,
                phone_no: this.mobile
              },
              {
                id: -1,
                phone_no: this.phone_profile
              }
            ],
            facebook_url: this.facebook,
            line_id: this.line,
            shop_status: this.openshop ? 'active' : 'inactive',
            public_show: this.publicshop ? 'yes' : 'no',
            merchant_key: this.merchant_key,

            // stepper2
            first_name: this.name_profile,
            last_name: this.last_name,
            shop_email: [{
              id: this.email_id,
              seller_email: this.email_profile
            }],
            shop_address: [
              {
                id: this.shop_address[0].id,
                default_address: this.default_address === 'main' ? 'main' : '',
                house_no: this.house_no,
                detail: this.details_profile,
                province: this.province,
                district: this.district,
                sub_district: this.subdistrict,
                zipcode: this.zipcode
              }
            ],

            // ที่ไม่ใช้
            partner_show: this.partner ? 'yes' : 'no',
            have_partner: this.publicshop ? 'yes' : 'no'
          }
          // console.log('data to API Edit', dataEdit)
          await this.$store.dispatch('actionsGraczEditSellerShopPage', dataEdit)
          var response = await this.$store.state.ModuleGraczShop.stateGraczEditSellerShopPage
          // var response = { code: '300' }
          if (response.code === 200) {
            this.$swal.fire({ text: 'บันทึกข้อมูลสำเร็จ', icon: 'success', timer: 2500, showConfirmButton: false })
            window.scrollTo(0, 0)
            this.Detail.product_image = []
            this.getDetailShop()
            if (this.MobileSize) {
              this.$router.push(`/Order/SellerShopDetailMobile/${this.shopName}-${this.seller_shop_id}`).catch(() => {})
              // this.$router.push({ path: '/Order/SellerShopDetailMobile/undefined-undefined' })
            } else {
              this.getShopName()
              this.$router.push(`/Order/SellerShopDetail/${this.shopName}-${this.seller_shop_id}`).catch(() => {})
              // this.$router.push({ path: '/Order/SellerShopDetail/undefined-undefined' })
            }
          } else {
            if (response.message === 'Not access this function.') {
              await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
              window.location.assign('/')
            } else {
              this.$swal.fire({ text: 'บันทึกข้อมูลไม่สำเร็จ', icon: 'error', timer: 2500, showConfirmButton: false })
            }
          }
          // console.log('res from API Edit', response)
        }
      } else {
        // console.log('form validate not pass')
        this.$swal.fire({ text: 'กรุณากรอกข้อมูลให้ถูกต้อง', icon: 'error', timer: 2500, showConfirmButton: false })
        this.v = true
      }
    },
    async getShopName () {
      console.log('GETEE')
      await this.$store.dispatch('actionsGraczUserDetail')
      var response = await this.$store.state.ModuleGraczUser.stateGraczUserDetail
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Get user detail selling success') {
        if (localStorage.getItem('UserDetailSelling') !== null) {
          var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
          var shopIndex = response.data.list_shop_detail.findIndex(e => e.seller_shop_id === userDetailSelling.seller_shop_id)
          await localStorage.setItem('GraczShopData', Encode.encode(response.data.list_shop_detail[shopIndex]))
          await localStorage.setItem('UserDetailSelling', Encode.encode(response.data.list_shop_detail[shopIndex]))
        }
        const customerDetail = {
          cus_name: '',
          cus_id: '',
          cus_code: '',
          channel_name: '',
          channel_id: '',
          cart_data: '',
          cus_address: '',
          onlinePurchaseStatus: true
        }
        await localStorage.setItem('OnlinePurchase', Encode.encode(customerDetail))
        this.$EventBus.$emit('getGraczShopName')
      } else if (response.message === 'This user is unauthorized.') {
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Channel not found. Please check and try again.') {
        return ['ไม่พบ Channel โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Shop not found. Please check and try again.') {
        return ['ไม่พบร้านค้า โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'An error has occurred. Please try again in an hour or two.') {
        return ['กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', 'error']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lans="scss">
  .v-application .success--text {
      color: #27AB9C !important;
      caret-color: #27AB9C !important;
  }
</style>
